import { Component, Input, Output, EventEmitter, SimpleChanges, ViewChild } from "@angular/core";
import { FormGroup, FormGroupDirective } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { NgSelectComponent } from "@ng-select/ng-select";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { EditDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/edit-delete.component";
import { AppCoreService } from "src/app/services/app-core.service";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import Swal from "sweetalert2";

@Component({
    selector: 'app-shared-charge',
    templateUrl: './charge.component.html',
    styleUrls: ['./charge.component.scss']
})

export class AwbChargesListComponent {
    @Input() forwardingInfo = false;
    @Input() chargeForm: FormGroup;
    @Input() awbForm: FormGroup;
    @Input() customerRowData = [];
    @Input() vendorRowData = [];
    @Input() chargesOptions = [];
    @Output() customerDataList = new EventEmitter<any[]>();
    @Output() chargeData = new EventEmitter<any>();
    @Output() vendorDataList = new EventEmitter<any[]>();
    @Output() forwardingChargeData = new EventEmitter<any>();
    @Input() customerConfig: any;
    @Output() chargesList = new EventEmitter<any[]>();

    @ViewChild('description') description: NgSelectComponent;
    @Output() focusEmit = new EventEmitter<boolean>();
    formSubmitted = false;
    chargeDetailsId: any;
    isChargesDetailsEdit = false;
    //chargesOptions: any[] = [];

    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;

    defaultColDef = {
        sortable: true,
        resizable: false,
        filter: true
    };

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 20,
        domLayout: 'autoHeight'
    }

    columnDefs = [
        //{ headerName: 'Description', field: 'chargesid' },
        { headerName: 'Description', field: 'chargesdescription', minWidth: 150 },
        { headerName: 'Amount', field: 'itemamount' },
        {
            headerName: 'Fuel', field: 'isitemfuel',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        {
            headerName: 'Fuel Amount', field: 'fuelamount',
            cellRenderer: (params: { data: { isitemfuel: boolean; fuelamount: number; }; }) => {
                return params.data.isitemfuel ? params.data.fuelamount : 0;
            }
        },
        {
            headerName: 'Fuel Tax', field: 'fueltax',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        // {
        //     headerName: 'Fuel Tax Amount', field: 'fueltaxamount',
        //     cellRenderer: (params: { data: { fueltax: boolean; fueltaxamount: number; }; }) => {
        //         return params.data.fueltax ? params.data.fueltaxamount : 0;
        //     }
        // },
        {
            headerName: 'Tax', field: 'tax',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
        },
        {
            headerName: 'IGST', field: 'igst',
            cellRenderer: (params: { data: { tax: boolean; igst: number; }; }) => {
                return params.data.tax ? params.data.igst : 0;
            }
        },
        {
            headerName: 'CGST', field: 'cgst',
            cellRenderer: (params: { data: { tax: boolean; cgst: number; }; }) => {
                return params.data.tax ? params.data.cgst : 0;
            }
        },
        {
            headerName: 'SGST', field: 'sgst',
            cellRenderer: (params: { data: { tax: boolean; sgst: number; }; }) => {
                return params.data.tax ? params.data.sgst : 0;
            }
        },
        { headerName: 'Total', field: 'itemtotal' },
        {
            headerName: 'System', field: 'system',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">Yes</span>';
                if (!params.value) {
                    statusHtml = '<span class="badge bg-success">No</span>';
                }
                return statusHtml;
            },
        },
        {
            headerName: 'Actions',
            field: 'id',
            cellRendererParams: { context: this },
            cellRenderer: EditDeleteActionsRenderer,
            colId: 'params',
            editable: false,
            sortable: false,
            minWidth: 50,
            filter: false
        },
    ];
    useEnterKey = false;
    constructor(
        private rootFormGroup: FormGroupDirective,
        private chargesService: ChargesService,
        private titleService: Title,
        private appCoreService: AppCoreService,
    ) {
        titleService.setTitle('Air Way Bill');
        this.context = { componentParent: this };
    }

    ngOnInit(): void {
        let chargesdetails = this.chargeForm.get('chargesdetails');
        //console.log('under customerRowData', this.customerRowData);
        //this.bindDescription();
        this.formateChargeGrid();
        this.getChargeValue();
        // console.log('customerConfig', this.customerConfig);
        this.useEnterKey = !this.appCoreService.GetUserData().metaInfo.tabbasedtemplate;
    }

    formateChargeGrid() {
        const formatTaxValues = (rowData: any[]) => {
            rowData.forEach(x => {
                if (!x) return; // Ensure x is not undefined or null

                x.igst = Number(x?.igst ?? x?.taxes?.tax?.igst ?? 0);
                x.sgst = Number(x?.sgst ?? x?.taxes?.tax?.sgst ?? 0);
                x.cgst = Number(x?.cgst ?? x?.taxes?.tax?.cgst ?? 0);
                x.vat = Number(x?.vat ?? x?.taxes?.tax?.vat ?? 0);
            });
        };

        if (this.customerRowData.length && this.customerRowData.some(x => x?.taxes)) {
            formatTaxValues(this.customerRowData);
        } else if (this.vendorRowData.length && this.vendorRowData.some(x => x?.taxes)) {
            formatTaxValues(this.vendorRowData);
        } else {
            formatTaxValues(this.customerRowData);
            formatTaxValues(this.vendorRowData);
        }
    }



    getCharges(index: any) {
        const chargesList = this.forwardingInfo ? this.vendorRowData : this.customerRowData;
        const chargeDetail = chargesList.find(item => item.id == index);

        if (!chargeDetail) {
            console.warn(`Charge with ID ${index} not found.`);
            return;
        }

        const chargeForm = this.chargeForm;
        const chargeDetailForm = chargeForm.get('chargesdetails');

        chargeDetailForm.get('txtDescription')?.setValue(chargeDetail.chargesid || '');
        chargeDetailForm.get('txtItemAmount')?.setValue(chargeDetail.itemamount ?? 0);
        chargeDetailForm.get('chkItemFuel')?.setValue(chargeDetail.isitemfuel ? 'Yes' : 'No');
        chargeDetailForm.get('txtFuelAmt')?.setValue(chargeDetail.fuelamount ?? 0);
        chargeDetailForm.get('chkFuelTax')?.setValue(chargeDetail.fueltax ? 'Yes' : 'No');
        chargeDetailForm.get('txtFuelTaxAmount')?.setValue(chargeDetail.fueltaxamount ?? 0);
        chargeDetailForm.get('chkTax')?.setValue(chargeDetail.tax ? 'Yes' : 'No');
        chargeDetailForm.get('txtTaxAmount')?.setValue(chargeDetail.taxamount ?? 0);
        chargeDetailForm.get('txtItemTotal')?.setValue(chargeDetail.itemtotal ?? 0);

        this.isChargesDetailsEdit = true;
        this.chargeDetailsId = index;
    }

    // fuel: true
    // tax: true
    // taxonfuel: true
    onKeyDown(event: KeyboardEvent) {
        // Access the key pressed
        // console.log('Key pressed:', event.key);

        // Perform additional logic based on the key pressed
        if (event.key === 'Enter') {
            this.upsertCharge();
        }
    }

    upsertCharge() {
        const chargeForm = this.chargeForm;
        const chargeDetailForm = chargeForm.get('chargesdetails');
        this.formSubmitted = true;
        if (!chargeDetailForm.valid) return;

        if (!this.isChargesDetailsEdit) {
            let chargesdescription = this.chargesOptions.find(x => x.id === chargeDetailForm.get('txtDescription')?.value)?.name || '';
            let charges = this.forwardingInfo ? this.vendorRowData : this.customerRowData;
            let chargeid = chargeDetailForm.get('txtDescription')?.value;
            if (charges.some(x => x.chargesid === chargeid)) {
                this.openWarningDialog(`<b>${chargesdescription}</b> already applied to the entry.`);
                return;
            }
        }

        const charge = this.calculateTaxCharge();
        const uniqueId = (this.forwardingInfo ? this.vendorRowData : this.customerRowData)?.length + 1;

        const data = {
            id: this.isChargesDetailsEdit ? this.chargeDetailsId : uniqueId,
            chargetype: this.forwardingInfo ? 'Vendor' : 'Customer',
            chargesid: chargeDetailForm.get('txtDescription')?.value || '',
            chargesdescription: this.chargesOptions.find(x => x.id === chargeDetailForm.get('txtDescription')?.value)?.name || '',
            itemamount: parseFloat((Number(chargeDetailForm.get('txtItemAmount')?.value) || 0).toFixed(3)),
            isitemfuel: chargeDetailForm.get('chkItemFuel')?.value === 'Yes',
            fuelamount: parseFloat((Number(chargeDetailForm.get('txtFuelAmt')?.value) || 0).toFixed(3)),
            fueltax: chargeDetailForm.get('chkFuelTax')?.value === 'Yes',
            fueltaxamount: parseFloat((Number(chargeDetailForm.get('txtFuelTaxAmount')?.value) || 0).toFixed(3)),
            tax: chargeDetailForm.get('chkTax')?.value === 'Yes',
            taxamount: parseFloat((Number(chargeDetailForm.get('txtTaxAmount')?.value) || 0).toFixed(3)),
            itemtotal: parseFloat((Number(chargeDetailForm.get('txtItemTotal')?.value) || 0).toFixed(3)),
            igst: (Number(charge.igst) || 0).toFixed(3),
            sgst: (Number(charge.sgst) || 0).toFixed(3),
            cgst: (Number(charge.cgst) || 0).toFixed(3),
            taxtype: 'gst',
            system: false
        };

        if (this.isChargesDetailsEdit) {
            if (this.forwardingInfo) {
                this.vendorRowData = this.vendorRowData.map(item => item.id === data.id ? { ...item, ...data } : item);
            } else {
                this.customerRowData = this.customerRowData.map(item => item.id === data.id ? { ...item, ...data } : item);
            }
        } else {
            if (this.forwardingInfo) {
                this.vendorRowData = [...this.vendorRowData, data];
            } else {
                this.customerRowData = [...this.customerRowData, data];
            }
        }

        this.sendData();
        this.resetCharges();
        this.getChargeValue();
    }


    // chargeFormControl() {
    //     const chargesDetails = this.chargeForm.get('chargesdetails');
    //     const chkItemFuelValue = chargesDetails.get('chkItemFuel')?.value;
    //     const chkFuelTax = chargesDetails.get('chkFuelTax')?.value;
    //     const chkTax = chargesDetails.get('chkTax')?.value;

    //     const enableDisableControl = (controlName, condition) => {
    //         const control = chargesDetails.get(controlName);
    //         control ? condition ? control.disable() : control.enable() : null;
    //     };

    //     enableDisableControl('txtFuelAmt', chkItemFuelValue === 'No');
    //     enableDisableControl('txtFuelTaxAmount', chkFuelTax === 'No');
    //     enableDisableControl('txtTaxAmount', chkTax === 'No');
    // }

    calculateTaxCharge(reverse = false): { igst: number, cgst: number, sgst: number, totaltax: number } {
        const itemamount = !reverse
            ? Number(this.chargeForm.get('chargesdetails.txtItemAmount')?.value) || 0
            : Number(this.chargeForm.get('chargesdetails.txtItemTotal')?.value) || 0;

        let igst = 0, cgst = 0, sgst = 0;

        if (this.customerConfig?.tax?.igst && this.customerConfig?.tax?.igstapplicable) {
            igst = (itemamount * Number(this.customerConfig.tax.igst)) / 100 || 0;
        } else {
            if (this.customerConfig?.tax?.cgst) {
                cgst = (itemamount * Number(this.customerConfig.tax.cgst)) / 100 || 0;
            }

            if (this.customerConfig?.tax?.sgst) {
                sgst = (itemamount * Number(this.customerConfig.tax.sgst)) / 100 || 0;
            }
        }

        const taxAmount = Number(igst) + Number(cgst) + Number(sgst);
        const totaltax = taxAmount || 0;

        return { igst, cgst, sgst, totaltax };
    }


    getChargeItemValue() {
        const defaultval: number = 0;
        const chargesDetails = this.chargeForm.get('chargesdetails');

        const getValue = (controlName) => {
            const control = chargesDetails?.get(controlName);
            return control && !isNaN(Number(control.value)) ? Number(control.value) : 0.00;
        };

        // charge_details-fields
        let itemAmount = getValue('txtItemAmount');
        const fuelAmountValue = getValue('txtFuelAmt');
        const fuelTaxAmount = getValue('txtFuelTaxAmount');
        const taxAmount = getValue('txtTaxAmount');

        if (isNaN(itemAmount) || isNaN(fuelAmountValue) || isNaN(fuelTaxAmount) || isNaN(taxAmount)) {
            console.error('Invalid input values detected');
            return;
        }

        const chkFuel = chargesDetails?.get('chkItemFuel')?.value;
        const chkfuelTax = chargesDetails?.get('chkFuelTax')?.value;
        const chkTax = chargesDetails?.get('chkTax')?.value;

        // this.chargeFormControl();
        const obj = this.calculateTaxCharge();

        if (chkFuel === 'Yes' && fuelAmountValue > 0) {
            chargesDetails.get('txtFuelAmt').setValue(fuelAmountValue.toFixed(3));
            itemAmount += fuelAmountValue;
            chargesDetails.get('txtItemTotal').setValue(itemAmount.toFixed(3));
        } else {
            chargesDetails.get('txtItemTotal').setValue(itemAmount.toFixed(3));
        }

        if (chkfuelTax === 'Yes' && fuelTaxAmount > 0) {
            chargesDetails.get('txtFuelTaxAmount').setValue(fuelTaxAmount.toFixed(3));
            itemAmount += fuelTaxAmount;
            chargesDetails.get('txtItemTotal').setValue(itemAmount.toFixed(3));
        } else {
            chargesDetails.get('txtItemTotal').setValue(itemAmount.toFixed(3));
        }

        if (chkTax === 'Yes' && taxAmount > 0) {
            const validTaxAmount = isNaN(taxAmount) ? 0 : taxAmount;
            chargesDetails.get('txtTaxAmount').setValue(validTaxAmount.toFixed(3));
            itemAmount += taxAmount;
            chargesDetails.get('txtItemTotal').setValue(itemAmount.toFixed(3));
        } else {
            chargesDetails.get('txtItemTotal').setValue(itemAmount.toFixed(3));
        }
    }

    getChargeValue() {
        const charge = this.chargeForm;
        let chargeOtherTotal = 0, chargeTotalFuel = 0, chargeTotalAmount = 0, contract_amount = 0, chargeSubTotal = 0;
        let igstTotal = 0, cgstTotal = 0, sgstTotal = 0;

        if (this.forwardingInfo) {
            for (const charge of this.vendorRowData) {
                const itemAmount = Number(charge?.itemamount ?? 0);
                const fuelAmount = Number(charge?.fuelamount ?? 0);
                const itemTotal = Number(charge?.itemtotal ?? 0);
                const igst = Number(charge?.igst ?? 0);
                const cgst = Number(charge?.cgst ?? 0);
                const sgst = Number(charge?.sgst ?? 0);

                if (charge?.chargesdescription?.toLowerCase() !== "freight") {
                    chargeOtherTotal += itemAmount;
                } else {
                    contract_amount += itemAmount;
                }

                chargeTotalFuel += fuelAmount;
                chargeTotalAmount += itemTotal;

                if (charge?.tax) {
                    igstTotal += igst;
                    sgstTotal += sgst;
                    cgstTotal += cgst;
                }
            }

            chargeSubTotal = chargeOtherTotal + contract_amount;
            const vendor = {
                contractcharges: contract_amount.toFixed(3),
                othercharges: chargeOtherTotal.toFixed(3),
                subtotal: chargeSubTotal.toFixed(3),
                totalfuel: chargeTotalFuel.toFixed(3),
                totalamount: chargeTotalAmount.toFixed(3),
                igst: igstTotal.toFixed(3),
                cgst: cgstTotal.toFixed(3),
                sgst: sgstTotal.toFixed(3)
            };

            this.forwardingChargeData.emit(vendor);
        } else {
            for (const charge of this.customerRowData) {
                const itemAmount = Number(charge?.itemamount ?? 0);
                const fuelAmount = Number(charge?.fuelamount ?? 0);
                const itemTotal = Number(charge?.itemtotal ?? 0);
                const igst = Number(charge?.igst ?? 0);
                const cgst = Number(charge?.cgst ?? 0);
                const sgst = Number(charge?.sgst ?? 0);

                if (charge?.chargesdescription?.toLowerCase() !== "freight") {
                    chargeOtherTotal += itemAmount;
                } else {
                    contract_amount += itemAmount;
                }

                chargeTotalFuel += fuelAmount;
                chargeTotalAmount += itemTotal;

                if (charge?.tax) {
                    igstTotal += igst;
                    sgstTotal += sgst;
                    cgstTotal += cgst;
                }
            }

            chargeSubTotal = chargeOtherTotal + contract_amount;
            const customer = {
                subtotal: chargeSubTotal.toFixed(3),
                othercharges: chargeOtherTotal.toFixed(3),
                contractcharges: contract_amount.toFixed(3),
                totalfuel: chargeTotalFuel.toFixed(3),
                totalamount: chargeTotalAmount.toFixed(3),
                igst: igstTotal.toFixed(3),
                cgst: cgstTotal.toFixed(3),
                sgst: sgstTotal.toFixed(3)
            };

            this.chargeData.emit(customer);
        }

        charge.get('txtSubTotal').setValue(chargeSubTotal.toFixed(3));
        charge.get('txtOtherCharges').setValue(chargeOtherTotal.toFixed(3));
        charge.get('txtContractCharges').setValue(contract_amount.toFixed(3));
        charge.get('txtTotalFuel').setValue(chargeTotalFuel.toFixed(3));
        charge.get('txtTotalAmount').setValue(chargeTotalAmount.toFixed(3));
        charge.get('txtIGST').setValue(igstTotal.toFixed(3));
        charge.get('txtCGST').setValue(cgstTotal.toFixed(3));
        charge.get('txtSGST').setValue(sgstTotal.toFixed(3));
    }

    resetCharges() {
        this.formSubmitted = false;
        this.isChargesDetailsEdit = false;
        const charge = this.chargeForm;
        const chargedetail = charge.get('chargesdetails');
        charge.reset();
        charge.get('ddlChargeType')?.setValue('Vendor');
        chargedetail.get('chkItemFuel').setValue('No');
        chargedetail.get('chkFuelTax').setValue('No');
        chargedetail.get('chkTax').setValue('No');
        charge.get('txtIGST').setValue('0.000');
        charge.get('txtCGST').setValue('0.000');
        charge.get('txtSGST').setValue('0.000');
        charge.get('txtContractCharges').setValue('0.000');
        charge.get('txtOtherCharges').setValue('0.000');
        this.focusFirstField()
    }

    preventWrongInput(event: KeyboardEvent): void {
        if (event.key === '-' || event.key === '+' || event.key === 'e') {
            event.preventDefault();
        }
    }

    getChargeDetail(event: any) {
        //console.log('event', event);
        let chargeDetailObj = this.chargesOptions.filter(x => x.id === event?.id);

        // console.log('chargeDetailObj', chargeDetailObj);

        let chargesdetails = this.chargeForm.get('chargesdetails');
        let taxigst = chargeDetailObj[0]?.tax ? (this.customerConfig?.tax?.igst * chargeDetailObj[0]?.rate / 100) : 0;
        let taxcgst = chargeDetailObj[0]?.tax ? (this.customerConfig?.tax?.cgst * chargeDetailObj[0]?.rate / 100) : 0;
        let taxsgst = chargeDetailObj[0]?.tax ? (this.customerConfig?.tax?.sgst * chargeDetailObj[0]?.rate / 100) : 0;

        let fueligst = chargeDetailObj[0]?.taxonfuel ? (this.customerConfig?.tax?.igst * chargeDetailObj[0]?.fuelamount / 100) : 0;
        let fuelcgst = chargeDetailObj[0]?.taxonfuel ? (this.customerConfig?.tax?.cgst * chargeDetailObj[0]?.fuelamount / 100) : 0;
        let fuelsgst = chargeDetailObj[0]?.taxonfuel ? (this.customerConfig?.tax?.sgst * chargeDetailObj[0]?.fuelamount / 100) : 0;

        let taxamount = taxigst ? taxigst : (taxcgst + taxsgst);
        let fueltaxamount = fueligst ? fueligst : (fuelcgst + fuelsgst);

        chargesdetails.get('txtItemAmount').setValue(chargeDetailObj[0]?.amount);
        chargesdetails.get('chkItemFuel').setValue(chargeDetailObj[0]?.fuel ? 'Yes' : 'No');
        chargesdetails.get('txtFuelAmt').setValue(chargeDetailObj[0]?.fuelamount || 0);
        chargesdetails.get('chkFuelTax').setValue(chargeDetailObj[0]?.taxonfuel ? 'Yes' : 'No');
        chargesdetails.get('txtFuelTaxAmount').setValue(fueltaxamount || 0);
        chargesdetails.get('chkTax').setValue(chargeDetailObj[0]?.tax ? 'Yes' : 'No');
        chargesdetails.get('txtTaxAmount').setValue(taxamount || 0);

        let total = (chargeDetailObj[0]?.rate);

        chargesdetails.get('txtItemTotal').setValue(total);
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }
    getFields(fieldName?: any) {
        return this.chargeForm.get(fieldName)?.value;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.resetCharges();
        this.getChargeValue();
    }

    sendData(): void {
        if (this.forwardingInfo) {
            this.vendorDataList.emit(this.vendorRowData);
        }
        else {
            this.customerDataList.emit(this.customerRowData);
        }
    }

    bindDescription() {
        try {
            this.chargesService.GetAll('').subscribe((res) => {
                if (res && res.success) {
                    this.chargesOptions = res.data;
                    this.chargesList.emit(this.chargesOptions);
                }
            });
        }
        catch (err) {
            console.error(err);
        }
    }


    editAction(cell: any) {
        try {
            if (cell) {
                // this.getChargeValue();
                this.getCharges(cell.id);
                // this.getChargeItemValue();
            }
        } catch (e) {
            console.error(e);
        }
    }

    async deleteAction(cell: any) {
        if (cell) {
            const confiremed = await this.openConfirmationDialog('Are you sure you want to delete ?');
            if (confiremed) {
                if (this.forwardingInfo) {
                    this.vendorRowData = this.vendorRowData.filter(item => item.id !== cell.id);
                    this.sendData();
                }
                else {
                    this.customerRowData = this.customerRowData.filter(item => item.id !== cell.id);
                    this.sendData();
                }
            }
        }
    }

    async calculateFuelTax(event?: any, isDescriptionChanged: boolean = false, manual = false) {
        const chargesdetails = this.chargeForm.get('chargesdetails');

        let chargeid = event?.id ?? chargesdetails.get('txtDescription').value;

        if (isDescriptionChanged) {
            ['txtItemAmount', 'chkItemFuel', 'txtFuelAmt', 'chkFuelTax', 'txtFuelTaxAmount', 'chkTax', 'txtTaxAmount']
                .forEach(field => chargesdetails.get(field).reset());
        }

        if (!this.validateRateFields() && chargeid) {
            await this.openWarningDialog(`The following details are mandatory: Product, Vendor, Service, Destination Country, and Actual Weight.`);
            this.resetCharges();
            return;
        }

        let chargeDetailObj = this.chargesOptions.find(x => x.id === chargeid);
        let chargeAmount = Number(chargesdetails.get('txtItemAmount').value ?? chargeDetailObj?.amount ?? 0);

        const isTaxApplicableOnCharge = manual ? chargesdetails.get('chkTax').value === 'Yes' : chargeDetailObj?.tax;
        const isFuelTaxApplicableOnCharge = manual ? chargesdetails.get('chkFuelTax').value === 'Yes' : chargeDetailObj?.taxonfuel;
        const isFuelApplicableOnCharge = manual ? chargesdetails.get('chkItemFuel').value === 'Yes' : chargeDetailObj?.fuel;

        let fuelAmount = 0;
        if (isFuelApplicableOnCharge) {
            let calculationBy = this.customerConfig?.fuel?.calculationby || "";
            let chargableFuel = Number(this.customerConfig?.fuel?.fuelcharge ?? 0);

            fuelAmount = calculationBy.toLowerCase() === "percentage"
                ? (chargeAmount * (chargableFuel / 100))
                : (calculationBy.toLowerCase() === "amount" ? chargableFuel : 0);
        }

        let fuel_igst = 0, fuel_sgst = 0, fuel_cgst = 0, taxFuelAmount = 0;
        let item_igst = 0, item_sgst = 0, item_cgst = 0, taxAmount = 0;

        const { igst = 0, sgst = 0, cgst = 0, is_igst_applicable = false } = this.customerConfig?.tax || {};

        if (isTaxApplicableOnCharge) {
            if (isFuelTaxApplicableOnCharge) {
                if (is_igst_applicable) {
                    fuel_igst = fuelAmount * (igst / 100);
                } else {
                    fuel_sgst = fuelAmount * (sgst / 100);
                    fuel_cgst = fuelAmount * (cgst / 100);
                }
                taxFuelAmount = fuel_igst + fuel_sgst + fuel_cgst;
            }

            if (is_igst_applicable) {
                item_igst = chargeAmount * (igst / 100);
            } else {
                item_sgst = chargeAmount * (sgst / 100);
                item_cgst = chargeAmount * (cgst / 100);
            }
            taxAmount = item_igst + item_sgst + item_cgst;
        }

        const item_total = chargeAmount + fuelAmount + taxFuelAmount + taxAmount;

        chargesdetails.get('txtItemAmount').setValue(chargeAmount.toFixed(3));
        !manual && chargesdetails.get('chkItemFuel').setValue(chargeDetailObj?.fuel ? 'Yes' : 'No');
        chargesdetails.get('txtFuelAmt').setValue(fuelAmount.toFixed(3));
        !manual && chargesdetails.get('chkFuelTax').setValue(chargeDetailObj?.taxonfuel ? 'Yes' : 'No');
        chargesdetails.get('txtFuelTaxAmount').setValue(taxFuelAmount.toFixed(3));
        !manual && chargesdetails.get('chkTax').setValue(chargeDetailObj?.tax ? 'Yes' : 'No');
        chargesdetails.get('txtTaxAmount').setValue(taxAmount.toFixed(3));
        chargesdetails.get('txtItemTotal').setValue(item_total.toFixed(3));
    }


    validateRateFields() {
        if (this.forwardingInfo)
            return true;

        let product = this.awbForm?.get('ddlProduct')?.value;
        let vendor = this.awbForm?.get('ddlVendor')?.value;
        let service = this.awbForm?.get('ddlService')?.value;
        let actualweight = Number(this.awbForm?.get('txtTotalActualWeight')?.value);
        let destination = this.awbForm?.get('consigneelocationdetails')?.get('ddlCountry')?.value;
        let isValidForm = false;

        if (product && vendor && service && actualweight !== 0 && destination)
            isValidForm = true;

        return isValidForm;
    }

    async openWarningDialog(msg: any) {
        await Swal.fire({
            title: 'Warning!',
            html: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false,
            allowEnterKey: true,
        })
    }
    
    async openConfirmationDialog(msg: any) {
        const result = await Swal.fire({
            title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showCancelButton: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
            allowEnterKey: true,
        })
        if (result.isConfirmed) {
            return true;
        } else return false;
    }

    reverseCalculation() {
        const chargeDetailForm = this.chargeForm.get('chargesdetails');
        const total_amount = chargeDetailForm.get('txtItemTotal').value || 0;

        //     if (total_amount <= 0) {
        //         return;
        //     }

        //     let item_amount = chargeDetailForm.get('txtItemAmount').value;
        //     const fuel_amount = chargeDetailForm.get('txtFuelAmt').value;
        //     const fuel_tax_amount = chargeDetailForm.get('txtFuelTaxAmount').value;
        //     const tax_amount = chargeDetailForm.get('txtTaxAmount').value;

        //     const chkFuel = chargeDetailForm.get('chkItemFuel').value;
        //     const chkfuelTax = chargeDetailForm.get('chkFuelTax').value;
        //     const chkTax = chargeDetailForm.get('chkTax').value;

        //     const obj = this.calculateTaxCharge(true);

        //     item_amount = total_amount || 0;

        //     if (chkFuel === 'Yes' && fuel_amount > 0) {
        //         item_amount = (total_amount - fuel_amount) || 0;
        //     }

        //     if (chkfuelTax === 'Yes' && fuel_tax_amount > 0) {
        //         item_amount = (total_amount - fuel_tax_amount) || 0;
        //     }

        //     if (chkTax === 'Yes' && obj.totaltax > 0) {
        //         item_amount = (total_amount - obj.totaltax) || 0;
        //     }

        //     chargeDetailForm.get('txtTaxAmount').setValue(obj.totaltax.toFixed(3));
        //     chargeDetailForm.get('txtItemAmount').setValue(Number(item_amount)?.toFixed(3));
        // }
    }
    calculateReverseAmount(): void {
        const finalAmount = parseFloat(this.chargeForm.get('chargesdetails.txtItemTotal').value) || 0;
        const chkFuel = this.chargeForm.get('chargesdetails.chkItemFuel').value;
        const chkfuelTax = this.chargeForm.get('chargesdetails.chkFuelTax').value;
        const chkTax = this.chargeForm.get('chargesdetails.chkTax').value;

        const igst = this.customerConfig?.tax?.igst || 0;
        const cgst = this.customerConfig?.tax?.cgst || 0;
        const sgst = this.customerConfig?.tax?.sgst || 0;
        const igstapplicable = this.customerConfig?.tax?.igstapplicable || false;

        let totaltax = igstapplicable ? igst : (cgst + sgst);

        const tax = totaltax || 0;
        const fuel = this.customerConfig?.fuel?.fuelcharge || 0;

        const taxPct = tax && chkTax === 'Yes' ? (tax + 100) : 100;
        const fuelPct = fuel && chkFuel === 'Yes' ? (fuel + 100) : 100;

        let returnAmount = taxPct ? (finalAmount / taxPct * 100) : finalAmount;
        const returnAmount1 = fuelPct ? (returnAmount / fuelPct * 100) : returnAmount;

        if (returnAmount1 > 0) {
            returnAmount = returnAmount1;
        }

        const fuelAmount = fuel && chkFuel === 'Yes' ? (returnAmount * fuel / 100) : 0;
        const taxAmount = tax && chkTax === 'Yes' ? (returnAmount * tax / 100) : 0;
        const fuelTaxAmount = tax && fuelAmount && chkfuelTax === 'Yes' ? (fuelAmount * tax / 100) : 0;

        this.chargeForm.get('chargesdetails.txtItemAmount').setValue(Number(returnAmount).toFixed(3));
        this.chargeForm.get('chargesdetails.txtFuelAmt').setValue(Number(fuelAmount).toFixed(3));
        this.chargeForm.get('chargesdetails.txtFuelTaxAmount').setValue(Number(fuelTaxAmount).toFixed(3));
        this.chargeForm.get('chargesdetails.txtTaxAmount').setValue(Number(taxAmount).toFixed(3));
    }

    focusFirstField() {
        if (this.description) {
            this.description.focus();
        }
    }
}